'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-pagination',
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnPageButtons = "".concat(CLASSNAME, "__pageButtons"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnPageButton = "".concat(CLASSNAME, "__pageButton"),
    cnPageButtonActive = "".concat(cnPageButton, "--active"),
    cnPageButtonDisabled = "".concat(cnPageButton, "--disabled"),
    cnButtonText = "".concat(CLASSNAME, "__buttonText");
/**
 * 
 * @param {*} param0 
 */

function Pagination(_ref) {
  var activePage = _ref.activePage,
      count = _ref.count,
      label = _ref.label,
      maxDisplay = _ref.maxDisplay,
      _onClick = _ref.onClick;

  var _useState = React.useState(0),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = React.useState([]),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      pages = _useState4[0],
      setPages = _useState4[1];

  var md = maxDisplay && maxDisplay % 2 === 1 ? maxDisplay : 9;
  React.useEffect(function () {
    var p = [];

    for (var i = 0; i < count; i++) {
      p.push(i);
    }

    if (count > md) {
      p = [0];
      var a = activePage !== null && activePage !== void 0 ? activePage : active;

      if (a <= Math.floor(md / 2)) {
        for (var j = 1; j < md - 2; j++) {
          p.push(j);
        }

        p.push('...');
      } else if (a >= count - Math.ceil(md / 2)) {
        p.push('...');

        for (var k = md - 2; k > 1; k = k - 1) {
          p.push(count - k);
        }
      } else {
        p.push('...');
        var range = Math.floor((md - 4) / 2);

        for (var l = a - range; l <= a + range; l++) {
          p.push(l);
        }

        p.push('...');
      }

      p.push(count - 1);
    }

    setPages(p);
  }, [active, activePage, count]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cnWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnPageButtons
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnLabel
  }, label), pages.map(function (e, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames(cnPageButton, (activePage >= 0 ? activePage === e : active === e) ? cnPageButtonActive : null, e === '...' ? cnPageButtonDisabled : null),
      onClick: function onClick() {
        if (e !== '...') {
          setActive(e);

          _onClick(e + 1);
        }
      },
      key: "paginationButton_".concat(e + idx)
    }, /*#__PURE__*/React__default.createElement("span", {
      className: cnButtonText
    }, e !== '...' ? e + 1 : '...'));
  })));
}
Pagination.propTypes = {
  /** Index of currently active page button to be controlled from outside */
  activePage: PropTypes.number,

  /** Total number of pages */
  count: PropTypes.number,

  /** Label to be left of page numbers */
  label: PropTypes.string,

  /** How many pages should be displayed at max (must be an odd number) */
  maxDisplay: PropTypes.number,

  /** Function that passes the clicked page number */
  onClick: PropTypes.func
};
Pagination.defaultProps = {
  count: 5,
  label: 'Pages',
  maxDisplay: 9
};

module.exports = Pagination;
